module.exports = __webpack_public_path__ + "static/media/about-shap.130cd4e3.svg";